import "angular"; 
import "angular-resource";
import "angular-ui-router";
import mfaController from "./MFAController";
import mfaVerifyCodeController from "./MFAVerifyCodeController";
import mfaFactory from "./MFAFactory.js";
import legSSOTokenRetrievalFactory from "../core/LegSSOTokenRetrievalFactory.js";
import routeStates from "./MFARoute";
import StateInterceptor from "../core/StateInterceptor";

// eslint-disable-next-line no-undef
var mfa = angular.module('mfa', ['ngResource', 'ui.router',   'focusDirectives']);
    
mfa.factory('StateInterceptor', StateInterceptor);  
 mfa.config(['$httpProvider',function($httpProvider){
$httpProvider.interceptors.push('StateInterceptor');
}]);    
    
mfa.controller('mfaController', mfaController);
mfa.controller('mfaVerifyCodeController', mfaVerifyCodeController);
mfa.factory('mfaFactory', mfaFactory);
mfa.factory('legSSOTokenRetrievalFactory', legSSOTokenRetrievalFactory);
mfa.config(routeStates);

export default mfa;